import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { Box, Button, Card, CardActionArea, Grid, Theme, Typography } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import { FC } from 'react';
import { PaymentMethodType } from '../gql-types.generated';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      padding: theme.spacing(2),
    },
    methodCard: {
      width: 160,
      border: `1.5px solid ${theme.palette.primary.main}`,
      borderRadius: theme.spacing(2),
      backgroundColor: '#FCFCFC',
    },
    cardContent: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(1),
    },
    icon: {
      fontSize: 48,
      color: theme.palette.primary.main,
    },
    addText: {
      textAlign: 'center' as const,
      fontSize: '15px',
      fontWeight: 'bold',
      color: theme.palette.primary.main,
    },
    paymentAction: {
      marginTop: 6,
      marginLeft: 4,
    },
    header: {
      paddingBottom: theme.spacing(1),
    },
  }),
);

interface PaymentMethodSelectionProps {
  cardAllowed: boolean;
  bankAllowed: boolean;
  onSelectPaymentType: (type: PaymentMethodType) => void;
  handleBack: () => void;
}

const PaymentMethodSelection: FC<PaymentMethodSelectionProps> = props => {
  const classes = useStyles();
  const { cardAllowed, bankAllowed, onSelectPaymentType, handleBack } = props;

  return (
    <Box className={classes.container}>
      <Typography variant="title" className={classes.header}>
        Pay Using
      </Typography>
      <Grid container spacing={2} justifyContent="center">
        {cardAllowed && (
          <Grid item>
            <Card className={classes.methodCard} variant="outlined">
              <CardActionArea onClick={() => onSelectPaymentType(PaymentMethodType.CreditCard)} data-cy="select-credit-card">
                <Box className={classes.cardContent}>
                  <CreditCardIcon className={classes.icon} />
                  <Typography className={classes.addText}>Add Card</Typography>
                </Box>
              </CardActionArea>
            </Card>
          </Grid>
        )}
        {bankAllowed && (
          <Grid item>
            <Card className={classes.methodCard} variant="outlined">
              <CardActionArea onClick={() => onSelectPaymentType(PaymentMethodType.PaymentBankUs)} data-cy="select-bank-account">
                <Box className={classes.cardContent}>
                  <AccountBalanceIcon className={classes.icon} />
                  <Typography className={classes.addText}>Add Account</Typography>
                </Box>
              </CardActionArea>
            </Card>
          </Grid>
        )}
      </Grid>
      <Grid container justifyContent="flex-start">
        <Button
          className={classes.paymentAction}
          color="primary"
          startIcon={<ArrowBackIcon />}
          onClick={handleBack}
          data-cy="back-to-billing"
        >
          BACK
        </Button>
      </Grid>
    </Box>
  );
};

export default PaymentMethodSelection;
